import { useState, useRef, useEffect } from "react";
import { any, arrayOf, bool, func, node, shape, string } from "prop-types";
import { useSelect } from "downshift";
import useClickAway from "../../common/useClickAway.js";
import cx from "classnames";
import "./select.scss";
import "./select-custom.scss";
import Select from "./Select.jsx";

import { object } from "prop-types";
import slugify from "slugify";
import * as R from "ramda";

const propTypes = {
  className: string,
  selected: object,
  disabled: bool,
  itemToId: func, // can use this instead of itemToString to identify an item
  label: node,
  // onChange shortcut for selectProps.onSelectedItemChange(item.selectedItem)
  // if this is used, you don't need to provide selectProps.onSelectedItemChange
  onChange: func,
  placeholder: node,
  activeSubdistributionClass: any,
  renderItem: func, // (item, isSelected) => node
  icon: node,
  selectProps: shape({
    items: arrayOf(any).isRequired,
    itemToString: func.isRequired,
    // anything else to go in to useSelect, like onSelectedItemChange or selectedItem
    // see https://github.com/downshift-js/downshift/tree/master/src/hooks/useSelect
    selectedItem: object,
  }).isRequired, // useSelect props
};

const defaultProps = {
  disabled: false,
};
const SubGroupSelect = (props) => {
  const {
    className,
    label,
    onChange,
    itemToId,
    placeholder,
    icon,
    selectProps,
    activeSubdistributionClass,
    ...otherProps
  } = props;

  const { items, itemToString, selectedItem } = selectProps;
  const [isOpen, setOpen] = useState(false);
  const groupMenu = useRef();
  const dropdown = useRef();
  useClickAway({ isOpen, setOpen, groupMenu });

  // const closeMenu = () => setOpen(false);
  // const flatItems = R.compose(R.flatten, R.map(R.prop("options")))(items);
  // flatItems;
  // console.log(flatItems);
  // const closeMenu = () => {
  //   setIsMainOpen(false);
  // };

  //main select
  const { getToggleButtonProps, getLabelProps, getMenuProps } = useSelect({
    items,
  });

  const renderItem =
    props.renderItem ||
    ((item) => (
      <>
        {itemToString(item)}
        <span className="select__checkmark-border select__checkmark-border--radio"></span>
      </>
    ));

  const hasSelection = selectedItem !== undefined && selectedItem !== null;

  const buttonText = placeholder;

  useEffect(() => {
    if (isOpen) {
      groupMenu.current.querySelectorAll(".select__button")[0].focus();
    }
  }, [isOpen]);

  return (
    <div
      className={cx("select", className, {
        "select--open": isOpen,
        "select--no-selection": !hasSelection,
      })}
      {...otherProps}
    >
      {label && (
        <label
          htmlFor="main-select-btn"
          className="select__label select__label--hidden"
          {...getLabelProps()}
        ></label>
      )}

      <div className="select__dropdown" ref={dropdown}>
        <div className="select__button-holder">
          <button
            className="select__button"
            type="button"
            id="main-select-btn"
            {...getToggleButtonProps({
              onClick: () => setOpen(!isOpen),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === "Space") {
                  // setOpen(!isOpen);
                  // e.nativeEvent.preventDownshiftDefault = true;
                } else if (e.key === "Escape") {
                  setOpen(false);
                  e.nativeEvent.preventDownshiftDefault = true;
                }
              },
            })}
          >
            <div className="select__button-text" title={buttonText}>
              {icon && <span className="select__button-icon">{icon}</span>}
              {buttonText}
            </div>
          </button>
        </div>
        {items && (
          <ul
            className="select__menu select__menu--grouped"
            {...getMenuProps({
              ref: groupMenu,
              onBlur: (e) => {
                setTimeout(() => {
                  if (!dropdown?.current?.contains(document.activeElement)) {
                    setOpen(false);
                  }
                }, 150);
              },
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === "Space") {
                  setOpen(true);
                  e.nativeEvent.preventDownshiftDefault = true;
                  return false;
                } else if (e.key === "Escape") {
                  setOpen(false);
                  e.nativeEvent.preventDownshiftDefault = true;
                  return false;
                }
              },
            })}
          >
            {items.map((section, sectionIndex) => {
              const { filterId, filterDefaultValue } = section;
              const uniqSlug = `${filterId}-${slugify(filterDefaultValue)}`;

              return (
                <li key={uniqSlug}>
                  <Select
                    label={filterDefaultValue}
                    renderItem={renderItem}
                    placeholder={filterDefaultValue}
                    itemToId={itemToId}
                    className={cx("select--nested", "select__sub-group-toggle")}
                    onChange={(change) => {
                      onChange(change, section.subdistributionClass);
                    }}
                    isSubGroup={true}
                    hideClear={true}
                    updateBtnText={false}
                    activeSubdistributionClass={activeSubdistributionClass}
                    selectProps={{
                      shouldOpen:
                        R.includes(selectedItem, section.options) && isOpen,
                      items: section.options,
                      itemToString: R.prop("value"),
                      selectedItem: R.includes(selectedItem, section.options)
                        ? selectedItem
                        : null,
                    }}
                  />
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

SubGroupSelect.propTypes = propTypes;
SubGroupSelect.defaultProps = defaultProps;
export default SubGroupSelect;
